'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animationFunctions = undefined;

var _animationFunctions = require('./animationFunctions');

var animationFunctions = exports.animationFunctions = [_animationFunctions.animation, _animationFunctions.animationDelay, _animationFunctions.animationDirection, _animationFunctions.animationDuration, _animationFunctions.animationFillMode, _animationFunctions.animationIterationCount, _animationFunctions.animationName, _animationFunctions.animationPlayState, _animationFunctions.animationTimingFunction];